import React from 'react'

const DashboardSuperAdmin = () => {
  return (
    <div>
        <h1>Dashboard Super Administrador</h1>
      
    </div>
  )
}

export default DashboardSuperAdmin
